import { render, staticRenderFns } from "./PurimTotals.vue?vue&type=template&id=229f6604&"
import script from "./PurimTotals.vue?vue&type=script&lang=js&"
export * from "./PurimTotals.vue?vue&type=script&lang=js&"
import style0 from "./PurimTotals.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports